<template>
    <Page>
        <Container>
            <div class="mx-auto max-w-sm">
                <Help>
                    Manage the movements in your workouts and decide how each one should be tracked.
                </Help>
                <MovementResourceList :key="$route.fullPath" />
            </div>
        </Container>
    </Page>
</template>

<script>
import {defineComponent} from 'vue'
import Help from '@/components/Help.vue';
import MovementResourceList from '@/components/Movement/ResourceList.vue';

export default defineComponent({
  name: 'Index',
  components: {
    Help,
    MovementResourceList,
  },
});
</script>

<style scoped lang="scss">

</style>
